import React, { PureComponent } from 'react';
import {Helmet} from 'react-helmet';
import { withRouter } from 'react-router-dom';
import ReactTable from "react-table";
import intl from 'react-intl-universal';

// import 'react-table/react-table.css';
// import 'react-table/react-table.css';

class Log extends PureComponent {
  constructor() {
    super();
    this.state = {
      data: [],
      pages: null,
      pageSize: 50,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
  }
  fetchData(state, instance) {

    // Only allow log#viewAs=Photoblog to see the logs
    
    if(location.hash !== '#viewAs=Photoblog') return;

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    fetch('/api/v1/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        page: state.page,
        pageSize: state.pageSize,
        sort: state.sort,
        filtered: state.filtered
      })
    })
    .then(res => res.json())
    .then(res => {
      console.log(res);
      this.setState({
        data: res.docs,
        pages: res.total,
        loading: false
      });
    });
  }

  render() {
    const { data, pages, loading, pageSize } = this.state;
    return (
      <div className='container'>
        <Helmet>
          <title>{intl.get('Log | ImageResize.org')}</title>
          <link rel="stylesheet" href="https://unpkg.com/react-table@latest/react-table.css" />
        </Helmet>
        <div>
          <ReactTable
            columns={[
              {
                Header: "Title",
                accessor: "title"
              },
              {
                Header: "Description",
                accessor: "description"
              },
              {
                Header: "Time",
                accessor: "createdAt"
              },
            ]}
            manual // Forces table not to paginate or sort automatically, so we can handle it server-side
            data={data}
            pages={pages} // Display the total number of pages
            loading={loading} // Display the loading overlay when we need it
            onFetchData={this.fetchData} // Request new data when things change
            filterable
            defaultPageSize={pageSize}
            className="-striped -highlight"
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Log);



// WEBPACK FOOTER //
// ./src/containers/Log/index.jsx